import React, { createContext, useState } from 'react'

export const GlobalContext = createContext()

export const GlobalProvider = ({ children }) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [apir, setApir] = useState('')
  const [cinfo, setCinfo] = useState('')
  const [brandingBlob, setBrandingBlob] = useState(null);

  const baseUrl = 'https://api.aa-vision.com'

  return (
    <GlobalContext.Provider
      value={{
        apir,
        setApir,
        cinfo,
        setCinfo,
        username,
        setUsername,
        password,
        setPassword,
        baseUrl,
        brandingBlob,
        setBrandingBlob,
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}
